import React, { Component} from 'react';
import Link from "./Link";
import "./MenuLinks.css"

export default class MenuLinks extends Component {
    constructor(props) {
        super(props);
        this.menuHover = this.menuHover.bind(this);
        this.state = {
            menuHover: false
        };
        this.menuStyle = {
            backgroundColor: this.props.menu.backgroundColor,
            content:  this.props.menu.text,
            color: this.props.menu.color
        };

        const images = require.context('../../img', true);

        this.home = images('./home.png');
        this.close = images('./close-btn.png');
    }

    menuHover() {
        const currentState = this.state.menuHover;
        this.setState({menuHover: !currentState});
    }

    render() {
        return (
            <div className={"sign-up"}>
            <style>{'.mobile-btn:before { content: "'+this.menuStyle.content+'";}'}</style>
            <span onClick={this.menuHover} className="mobile-btn">
                <img src={this.home} alt="menu"/>
                <img className={"close-btn " + (this.state.menuHover ? '' : 'hidden')} src={this.close} alt="menu"/>
            </span>

                <div
                    style={this.menuStyle}
                    className={"top-banner__top-menu top-banner__top-menu-nav "+ (this.state.menuHover ? 'top-menu-nav--open' : '')}
                >
                    <nav>
                        <ul className="main-menu clearfix">
                            {
                                this.props.menu.links.map((option, key) => (<Link key={key} color={this.menuStyle.color} src={option.src} text={option.text} {...this.props} />))
                            }
                        </ul>
                    </nav>
                    </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MenuLinks/MenuLinks.js